import React, { useCallback } from 'react'
import type { ConfirmModalProps } from '@/core/types/confirm-modal'
import ConfirmModal from '../components/confirm-modal'

const ConfirmModalContext = React.createContext<{
  askUser: (props: ConfirmModalProps<unknown>) => void
}>({
  askUser: () => {}
})

export const ConfirmModalProvider = ({
  children
}: {
  children?: React.ReactNode
}) => {
  const [open, setOpen] = React.useState(false)
  const [props, setProps] = React.useState<ConfirmModalProps<unknown>>({
    onConfirm: () => {}
  })

  const askUser = useCallback(<T,>(_props: ConfirmModalProps<T>) => {
    setProps(_props)
    setOpen(true)
  }, [])

  return (
    <ConfirmModalContext.Provider value={{ askUser }}>
      <ConfirmModal open={open} setOpen={setOpen} {...props} />
      {children}
    </ConfirmModalContext.Provider>
  )
}

export const useConfirmModal = () => {
  const context = React.useContext(ConfirmModalContext)
  if (!context) {
    throw new Error(
      'useConfirmModal must be used within a ConfirmModalProvider'
    )
  }
  return context
}
